export default {
  DATETIME: {
    RESET: 'Zurücksetzen',
    SUBMIT: 'Bestätigen',
    PLACEHOLDER: 'Startzeit',
  },
};
